import { logError } from 'client/javascript/util/logger';
import { setupBrowseByNeedsModule } from 'client/javascript/pages/shared/sections/hero_container/browse_by_needs';
import { setupHeroModule } from 'client/javascript/pages/shared/sections/hero_container/hero';

export const SELECTORS = {
  MODULE: '.hero-container'
};
export const ROLLBAR_LOGGING_PREFIX = '[Hero Container]';

export const setupHeroContainerSection = async () => {
  try {
    const moduleDomNode = document.querySelector(SELECTORS.MODULE);

    if (!moduleDomNode) {
      return;
    }

    await Promise.all([setupBrowseByNeedsModule(), setupHeroModule()]);
  } catch (error) {
    logError(`${ROLLBAR_LOGGING_PREFIX} setupHeroContainerSection failed: ${error.message}`, error);
  }
};
